import styles from './option.module.css'

const Option = props => (
  <button
    className={styles.option}
    onClick={props.onClick}
    data-option
    tabIndex={!props.active ? -1 : null}
    aria-disabled={!props.active ? true : null}
  >
    {props.children}
  </button>
)

export default Option
